// Selector to get the current theme from the state
import { StoreState } from "../types/StoreState";

const getDownloadSnacks = (state: StoreState) => {
  return state.coreState.downloadSnackBars;
};

export default getDownloadSnacks;
